<div class="results-container">
  <h2 class="page-title">Resultados</h2>

  <div class="filter-bar">
    <div class="date-fields">
      <div class="date-field">
        <label for="since">Data inicial</label>
        <p-datepicker inputId="since" dateFormat="dd/mm/yy" [(ngModel)]="since" [readonlyInput]="true"
          placeholder="Selecione a data inicial" />
      </div>

      <div class="date-field">
        <label for="until">Data final</label>
        <p-datepicker inputId="until" dateFormat="dd/mm/yy" [(ngModel)]="until" [readonlyInput]="true"
          placeholder="Selecione a data final" />
      </div>

      <button class="btn-pesquisar" (click)="applyDateFilter()" [disabled]="isLoading">
        Filtrar
      </button>
    </div>

    <div class="action-buttons">
      <button class="btn-export" (click)="exportToCsv()" [disabled]="isLoading || !rows.length"
        title="Exportar dados para CSV">
        Exportar CSV
      </button>

      <button class="btn-refresh" (click)="clearFiltersAndRefresh()" [disabled]="isLoading" title="Atualizar">
        <i class="pi pi-refresh"></i>
      </button>
    </div>
  </div>

  <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>

  <p-table [value]="rows" [loading]="isLoading" [paginator]="true" [rows]="30" [rowsPerPageOptions]="[15, 30]">
    <ng-template pTemplate="header">
      <tr>
        <th>Data</th>
        <th>Contas Cadastradas</th>
        <th>Vínculos LoL</th>
        <th>Vínculos CS</th>
        <th>Batalhas LoL</th>
        <th>TR LoL (R$)</th>
        <th>Batalhas CS</th>
        <th>TR CS (R$)</th>
        <th>Nº Compras Moedas</th>
        <th>Valor Compras Moedas</th>
        <th>Nº Saques</th>
        <th>Valor Saques</th>
        <th>Depósito - Saques</th>
        <th>Ticket Médio</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row>
      <tr>
        <td>{{ row.date | date: 'dd/MM/yyyy' }}</td>
        <td>{{ row.accounts_created_count || 0 }}</td>
        <td>{{ row.lol_links_count || 0 }}</td>
        <td>{{ row.cs_links_count || 0 }}</td>
        <td>{{ row.lol_battles_count || 0 }}</td>
        <td>{{ (row.lol_take_rate || 0) | number: '1.2-2' }}</td>
        <td>{{ row.cs_battles_count || 0 }}</td>
        <td>{{ (row.cs_take_rate || 0) | number: '1.2-2' }}</td>
        <td>{{ row.coin_purchases_count || 0 }}</td>
        <td>{{ (row.coin_purchases_value || 0) | number: '1.2-2' }}</td>
        <td>{{ row.withdrawals_count || 0 }}</td>
        <td>{{ (row.withdrawals_value || 0) | number: '1.2-2' }}</td>
        <td>{{ (row.deposit_vs_withdraw_diff || 0) | number: '1.2-2' }}</td>
        <td>{{ (row.avg_ticket || 0) | number: '1.2-2' }}</td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="14" class="empty-message">Nenhum dado encontrado.</td>
      </tr>
    </ng-template>
  </p-table>
</div>